import de from './de';

export const messages = {
  'de': de
};
